import React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../app/context'
import { Entity } from '../app/entity'
import Navigator from '../app/navigator'
import { ServiceType } from '../domain/ServiceType'
import { Snapshot } from '../domain/Snapshot'
import Loading from '../helper/loading'
import LoadingCover from '../helper/loadingCover'
import { ApplicationState } from '../redux/ApplicationState'
import { Col, Row } from '../ui/grid'
import Link from './../helper/link'
import Graph from './graph'
import Introspection from './Introspection'
import TransactionTableRowItem from './transaction-table-row-item'
import Profile from './profile'
import SnapshotNavigation from './snapshot-navigation'
import SnapshotModel from './snapshot/snapshotModel'
import SortableColumnHeader from './operation/sortable-column-header'
import BoxBody from '../helper/boxBody'

interface OwnProps {
    showGraph: boolean
}

type StateProps = Entity<Snapshot | null> & {
    tidewaysContext: TidewaysContext
    navigator: Navigator
    parameters: { [key: string]: string }
}

interface State {
    activeTab: 'transactions' | 'traces'
}

type Props = OwnProps & StateProps

class SnapshotComponent extends React.Component<Props, State> {
    public static defaultProps = {
        showGraph: true,
        loading: false,
        data: null,
    }

    public state: State = {
        activeTab: 'transactions',
    }

    public render() {
        const snapshot = SnapshotModel.fromParameters(this.props.parameters)
        const sort = this.props.parameters.sort || 'impact'
        const listParams = this.props.data
            ? {
                  minDate: this.props.parameters.date || '',
                  maxDate: this.props.parameters.end || '',
                  services: [this.props.data.tidewaysContext.selectedService],
              }
            : {}

        return (
            <>
                <SnapshotNavigation activeType={ServiceType.php} />
                <div className="row operation-list">
                    {this.props.showGraph ? (
                        <div className="col-md-12 monitor application-graph jquery-tooltip-reference">
                            <Graph responseType="95p" />
                        </div>
                    ) : null}

                    <div className="col-lg-12">
                        <Row>
                            <Col width={8}>
                                <ul className="nav nav-pills nav-pills-tideways">
                                    <li
                                        className={this.state.activeTab === 'transactions' ? 'active' : ''}
                                        onClick={() => this.setState({ activeTab: 'transactions' })}
                                    >
                                        <a>Transactions</a>
                                    </li>
                                    <li
                                        className={this.state.activeTab === 'traces' ? 'active' : ''}
                                        onClick={() => this.setState({ activeTab: 'traces' })}
                                    >
                                        <a>Traces</a>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                        {this.props.data ? (
                            <div className="tab-content no-padding">
                                {this.state.activeTab === 'transactions' ? (
                                    <div className="tab-pane active" id="transactions">
                                        <div className="box">
                                            <Introspection data={this.props.data} snapshot={snapshot} />
                                            <BoxBody {...this.props} className="no-padding">
                                                {this.props.loading ? <LoadingCover /> : null}
                                                <table className="table table-striped profile table-fixed">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th style={{ width: 100 }} className="align-right">
                                                                <SortableColumnHeader
                                                                    label={'Requests'}
                                                                    sortKey={'requests'}
                                                                    currentSortKey={sort}
                                                                />
                                                            </th>
                                                            <th style={{ width: 170 }} className="align-right">
                                                                <SortableColumnHeader
                                                                    label={'Average Response'}
                                                                    sortKey={'average'}
                                                                    currentSortKey={sort}
                                                                />
                                                            </th>
                                                            <th style={{ width: 160 }} className="align-right">
                                                                <SortableColumnHeader
                                                                    label={'Slowest Response'}
                                                                    sortKey={'max'}
                                                                    currentSortKey={sort}
                                                                />
                                                            </th>
                                                            <th style={{ width: 110 }} className="align-right">
                                                                <SortableColumnHeader
                                                                    label={'Memory'}
                                                                    sortKey={'memory'}
                                                                    currentSortKey={sort}
                                                                />
                                                            </th>
                                                            <th style={{ width: 110 }} className="align-right">
                                                                <SortableColumnHeader
                                                                    label={'Failures'}
                                                                    sortKey={'errors'}
                                                                    currentSortKey={sort}
                                                                />
                                                            </th>
                                                            <th style={{ width: 110 }} className="align-right">
                                                                <SortableColumnHeader
                                                                    label={'Impact'}
                                                                    sortKey={'impact'}
                                                                    currentSortKey={sort}
                                                                />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.props.data.transactions ? (
                                                            this.props.data.transactions.map((operation, id) => {
                                                                return (
                                                                    <TransactionTableRowItem
                                                                        key={id}
                                                                        operation={operation}
                                                                        full
                                                                        route="XhprofProfilerBundle.OperationSnapshot.show"
                                                                        parameters={snapshot.toParameters()}
                                                                        isTideways6={this.props.tidewaysContext.organization.isTideways6}
                                                                    />
                                                                )
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={7} className="text-center">
                                                                    No transactions occured in selected period.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </BoxBody>
                                        </div>
                                    </div>
                                ) : null}
                                {this.state.activeTab === 'traces' ? (
                                    <div className="tab-pane active" id="traces">
                                        <div className="box">
                                            <Introspection data={this.props.data} snapshot={snapshot} />
                                            <BoxBody {...this.props} className="no-padding">
                                                {this.props.loading ? <LoadingCover /> : null}
                                                <table className="table table-condensed profile-list">
                                                    {this.props.data.profiles.profiles && this.props.data.profiles.profiles.length ? (
                                                        this.props.data.profiles.profiles.map((profile, index) => {
                                                            return (
                                                                <Profile
                                                                    key={profile.id}
                                                                    rowType={index % 2 ? 'even' : 'odd'}
                                                                    profile={profile}
                                                                    link={this.props.navigator.path('XhprofProfilerBundle.Profile.quick', {
                                                                        profile: profile.id,
                                                                    })}
                                                                />
                                                            )
                                                        })
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={8} className="text-center">
                                                                    No traces found in selected date range.
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}

                                                    <tfoot>
                                                        {this.props.data.profiles.profiles && this.props.data.profiles.profiles.length ? (
                                                            <tr>
                                                                <td colSpan={8} className="text-center">
                                                                    <strong>
                                                                        <Link route="XhprofProfilerBundle.Profile.list" query={listParams}>
                                                                            Show all {this.props.data.profiles.total} traces
                                                                        </Link>
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </tfoot>
                                                </table>
                                            </BoxBody>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <Loading {...this.props} title="Introspection" height={100} />
                        )}
                    </div>
                </div>
            </>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    const snapshot = globalState.snapshots.snapshot || new Entity()

    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route, globalState.tidewaysContext.router),
        parameters: globalState.tidewaysContext.route.parameters,
        ...snapshot,
    }
})(SnapshotComponent)
